import { LoginCallback } from '@okta/okta-react';

const ImplicitCallback = (): React.JSX.Element => <LoginCallback />;

export default ImplicitCallback;
